import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import dayjs from 'dayjs';
import classNames from 'classnames';

export default function DeadlineList(props) {
  const {
    deadlines,
    state,
    setState
  } = props;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentDeadlineValue, setCurrentDeadlineValue] = useState('');

  const onResize = (e) => {
    setTimeout(() => {
      setWindowWidth(e.target.innerWidth);
    }, 500);
  }

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    }
  }, []);

  useEffect(() => {
    setCurrentDeadlineValue(state.deadline.value);
  }, [state.deadline.value]);
  return (
    <Fragment>
      {windowWidth > 768 && (
        <div className="deadlines-list"
             style={{
               gridTemplateColumns: `repeat(${deadlines.length}, 1fr)`
             }}
        >
          {deadlines.map(item => {
            return (
              <button
                className={classNames('deadlines-list__item', {
                  'deadlines-list__item--active': state?.deadline?.id === item.id
                })}
                key={item.id}
                data-value={item.id}
                onClick={(e) => {
                  e.preventDefault();
                  setState({
                    ...state,
                    deadline: {
                      ...state.deadline,
                      id: item.id,
                      name: item.name,
                      value: dayjs()
                        .add(+item.hours, 'hours')
                        .format('MMM DD, YYYY [at] HH:mm A')
                        .toString()
                    }
                  });
                }}
              >
                {item.shortName}
              </button>
            )
          })}
        </div>
      )}
      {windowWidth < 768 && (
        <div className="select">
          <select onChange={(e) => {
            const selectedDeadline = deadlines.filter(i => i.id === +e.target.value)[0];
            setState({
              ...state,
              deadline: {
                ...state.deadline,
                id: e.target.value,
                name: selectedDeadline.name,
                value: dayjs()
                  .add(selectedDeadline.hours, 'hours')
                  .format('MMM DD, YYYY [at] HH:mm A')
                  .toString()
              }
            });
          }}>
            {deadlines.map(item => {
              return (
                <option
                  className={classNames('deadlines-list__item', {
                    'deadlines-list__item--active': state?.deadline?.id === item.id
                  })}
                  key={item.id}
                  value={item.id}
                >
                  {item.shortName}
                </option>
              )
            })}
          </select>
        </div>
      )}

      <p className="deadline-date">We'll send you the order for review by <strong>{currentDeadlineValue}.</strong></p>
    </Fragment>
  )
}
